export default {
  bind(el) {
    el.addEventListener('focus', () => {
      el.select();
    });
  }
};